var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6443,
    d: "M118.723 100.662C118.723 113.427 94.8433 123.774 65.39 123.774C35.934 123.774 12.0566 113.427 12.0566 100.662C12.0566 87.8994 35.934 77.5527 65.39 77.5527C94.8433 77.5527 118.723 87.8994 118.723 100.662Z",
    fill: "url(#paint0_radial_37_44000)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.869 61.3969C115.869 90.0796 92.616 113.333 63.9333 113.333C35.2507 113.333 12 90.0796 12 61.3969C12 32.7143 35.2507 9.46094 63.9333 9.46094C92.616 9.4636 115.869 32.7143 115.869 61.3969Z",
    fill: "url(#paint1_radial_37_44000)",
    stroke: "#197A1B",
    strokeWidth: 1.4896
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.78 60.6617C102.78 82.083 85.415 99.4483 63.9937 99.4483C42.5724 99.4483 25.207 82.083 25.207 60.6617C25.207 39.2403 42.5724 21.875 63.9937 21.875C85.415 21.875 102.78 39.2403 102.78 60.6617Z",
    fill: "url(#paint2_radial_37_44000)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3763,
    d: "M112.618 61.3975C112.618 88.2855 90.8207 110.083 63.9327 110.083C37.0447 110.083 15.25 88.2855 15.25 61.3975C15.25 34.5095 37.0473 12.7148 63.9327 12.7148C90.8233 12.7148 112.618 34.5095 112.618 61.3975Z",
    stroke: "url(#paint3_linear_37_44000)",
    strokeWidth: 1.5891
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2375 34.0053C78.4082 33.92 77.5842 34.328 77.1602 35.1066L59.0215 68.296L47.3602 59.024C46.3175 58.456 45.0242 58.8213 44.4562 59.8586L39.2269 66.5733C38.6562 67.6133 39.0429 68.9066 40.0775 69.4746C40.0775 69.4746 61.3735 87.064 61.4002 87.0773C61.6429 87.2106 61.8989 87.2773 62.1575 87.3093C63.0002 87.416 63.8669 87.0213 64.3015 86.224L88.7629 41.464C89.3335 40.424 88.9495 39.1306 87.9122 38.5626L80.0642 34.256C79.8029 34.112 79.5122 34.0346 79.2375 34.0053Z",
    fill: "#089600",
    stroke: "#197A1B",
    strokeWidth: 0.956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M78.1005 36.5528L68.9085 53.4408L60.7192 68.3342C60.4525 68.6008 60.5352 69.4488 59.3832 69.7422C58.5832 69.9475 58.4392 69.6488 57.5992 69.1102L47.3112 60.9822C46.1672 60.0622 46.2019 60.1102 45.3885 60.9262L41.2579 66.1368C40.1432 67.3288 40.3139 68.0488 41.7032 68.9395C41.7032 68.9395 61.0659 84.8968 61.0899 84.9102C61.3219 85.0355 61.2232 85.0782 62.2125 85.7635C62.8472 86.2062 63.4072 84.8062 63.8179 84.0568L87.3592 41.1022C87.8925 40.1262 87.8525 40.1395 86.8659 39.6008L79.8472 35.8782C78.8339 35.3315 78.8285 35.3368 78.1005 36.5528Z",
    stroke: "url(#paint4_linear_37_44000)",
    strokeWidth: 0.956,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_37_44000",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.3913 100.647) scale(53.3324 23.1104)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_37_44000",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.6007 33.062) scale(81.604 81.604)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08F000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B7B00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_37_44000",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.9974 41.2114) scale(51.0643)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDFDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_37_44000",
    x1: -750.667,
    y1: 1121.33,
    x2: -748.001,
    y2: 1121.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_37_44000",
    x1: -750.667,
    y1: 1121.33,
    x2: -748.001,
    y2: 1121.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicMark);
export default __webpack_public_path__ + "static/media/tic_mark.de3566ad241aee331a1ff27e85d8f15a.svg";
export { ForwardRef as ReactComponent };